import PropTypes from 'prop-types';
// material
import { Popover } from '@material-ui/core';
import { alpha, styled, useTheme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

const ArrowStyle = styled('span')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    top: -7,
    zIndex: 1,
    width: 12,
    right: 20,
    height: 12,
    content: "''",
    position: 'absolute',
    borderRadius: '0 0 4px 0',
    transform: 'rotate(-135deg)',
    background: theme.palette.background.paper,
    borderRight: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
    borderBottom: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`
  }
}));

// ----------------------------------------------------------------------

MenuPopover.propTypes = {
  children: PropTypes.node.isRequired,
  styles: PropTypes.object
};

export default function MenuPopover({ children, styles, ...other }) {
  const theme = useTheme();
  return (
    <Popover
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
       style: {
         marginTop: theme.spacing(1.5),
         marginLeft: theme.spacing(0.5),
         overflow: 'inherit',
         boxShadow: theme.customShadows.z20,
         width: 200,
         padding: theme.spacing(1),
         ...styles
       }
      }}
      {...other}
    >
      <ArrowStyle className="arrow" />

      {children}
    </Popover>
  );
}
